import React, { useState } from "react";
import { observer } from "mobx-react-lite";
import FormModal from "../../FormModal/FormModal";
import s from "../UploadIssueModal/UploadIssueModal.module.scss";
import RoundButton from "../../RoundButton/RoundButton";
import { Typography } from "@progress/kendo-react-common";
import { Form } from "@progress/kendo-react-form";
import { FormInputs } from "src/main";
import moment from "moment";
import { REQUEST_DATE_FORMAT } from "@iliotech/data-wire";
export interface WhatIfDateModalProps {
  handleClose: () => void;
  onSave: (anchorDate: string) => void;
  buttonLoading?: boolean;
  visible: boolean;
}

const DEFAULT_WHAT_IF_DATE = moment().subtract(1, "year").toDate();
const MIN_WHAT_IF_DATE = moment().subtract(5, "year").toDate();

export const WhatIfDateModal = (props: WhatIfDateModalProps) => {
  const { handleClose, visible, onSave, buttonLoading } = props;

  const [date, setDate] = useState(DEFAULT_WHAT_IF_DATE);
  const handleSubmit = () => {
    onSave(moment(date).format(REQUEST_DATE_FORMAT));
  };

  return (
    <FormModal
      hideClose={true}
      visible={visible}
      handleClose={handleClose}
      footer={
        <div className={s.footer}>
          <RoundButton fillMode={"outline"} onClick={handleClose}>
            Cancel
          </RoundButton>
          <RoundButton
            onClick={handleSubmit}
            loading={buttonLoading}
            className={s.save}
          >
            Create Scenario
          </RoundButton>
        </div>
      }
    >
      <div className={s.container}>
        <Typography.h3 fontWeight={"bold"} style={{ marginBottom: 25 }}>
          Create Scenario
        </Typography.h3>
        <Typography.p>
          Please enter the desired start date for your what if scenario, or
          leave blank to use one year ago (Default date) :
        </Typography.p>
        <Typography.p>What if scenario date:</Typography.p>
        <FormInputs.DatePicker
          onChange={(e) => setDate(e.value!)}
          required
          min={MIN_WHAT_IF_DATE}
          defaultValue={DEFAULT_WHAT_IF_DATE}
          name="date"
        />
      </div>
    </FormModal>
  );
};
